import React, { Component } from 'react';
import { Row, Col, Icon, Button, Divider, Collapse } from 'antd';
import RegistrationCode422Modal from './RegistrationCode422Modal';

// PersonNotUniqueException (solr match or solr unreachable)
export default class RegistrationCode422 extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const
        { data } = this.props,
        { showPasswordResetModal, toggleModalPasswordResetRequest, captchaServices } = data;

        return (
            <div style={{ zIndex: '1' }}>
                <div
                    className='ss-cmpts-reg-error-candidate-card'
                    style={!showPasswordResetModal ? {} : {
                        filter: 'grayscale(100%) blur(5px)'
                    }}
                >
                    <div style={{ textAlign: 'center', marginBottom: '4px' }}>
                        <span className='ss-cmpts-reg-error-header-title' style={{ fontSize: '1.5em' }}>
                            {'Error Creating Your Account'}
                        </span>
                    </div>
                    <div className='ss-cmpts-reg-error-422-sub-title'>
                        {'You may already have an AFSP account'}
                    </div>
                    <Row type='flex' justify='space-around' align='middle'>
                        <Col span={24}>
                            <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '20px' }}>
                                <Col span={24}>
                                    <div className='ss-cmpts-reg-error-422-desc'>
                                        {'We were unable to complete your registration because '}
                                        <span style={{ fontWeight: 'bold' }}>
                                            {'the information you entered may be associated with an existing account.'}
                                        </span>
                                    </div>
                                </Col>
                            </Row>
                            <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '20px' }}>
                                <Col span={23}>
                                    <div className='ss-cmpts-reg-error-422-warning'>
                                        <Icon type='warning' style={{ color: 'rgb(225, 186, 0)', marginRight: '10px' }} />
                                        <span style={{ fontWeight: 'bold' }}>
                                            {'DO NOT '}
                                        </span>
                                        {'try to create another account.'}
                                    </div>
                                </Col>
                            </Row>
                            <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '20px' }}>
                                <Col span={23} style={{ textAlign: 'left'}}>
                                    <Collapse bordered={false} defaultActiveKey={[]}>
                                        <Collapse.Panel style={{
                                            background: '#f7f7f7',
                                            borderRadius: '5px',
                                            borderStyle: 'solid',
                                            borderColor: '#ccc',
                                            borderWidth: '1px',
                                            overflow: 'hidden'
                                        }} header={(
                                            <span style={{ fontStyle: 'italic', fontWeight: 'bold' }}>
                                                {'Don\'t have an account?'}
                                            </span>
                                        )}>
                                            <div style={{ marginLeft: '10%', lineHeight: '17px' }}>
                                                <span>
                                                    {'Contact AFSP Help Desk for assistance:'}
                                                </span>
                                                <div>
                                                    <ul>
                                                        <li>
                                                            <a href='mailto:FTSP.Help@tsa.dhs.gov'>
                                                                {'FTSP.Help@tsa.dhs.gov'}
                                                            </a>
                                                        </li>
                                                        <li>
                                                            {'(571) 227-1004'}
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </Collapse.Panel>
                                    </Collapse>
                                </Col>
                            </Row>
                            <Row type='flex' justify='space-around' align='middle' style={{ textAlign: 'left' }}>
                                <Col span={23}>
                                    <div className='ss-cmpts-reg-error-422-retreive-password'>
                                        {'Do you have an account already?'}
                                    </div>
                                    <Button
                                        size='small'
                                        icon='rollback'
                                        style={{ width: '100%', borderRadius: '20px' }}
                                        disabled={showPasswordResetModal}
                                        onClick={() => {captchaServices.resetCaptchaValidation(); toggleModalPasswordResetRequest()}}
                                    >
                                        {'Retrieve Password'}
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <RegistrationCode422Modal data={data} />
            </div>
        );
    }
}
